module.exports = __webpack_public_path__ + "img/treatment_area.74bf1adf.png";